<template>
  <div :class="classnames" v-if="activeFilters.length">
    <ul :class="`${ns}__items`">
      <template v-for="filter in activeFilters">
        <li :class="`${ns}__item`">
          <ActiveFiltersListItem :id="filter.id" @click="handleItemClick($event, filter.id)">
            {{ filter.title }}
          </ActiveFiltersListItem>
        </li>
      </template>

      <template v-if="hasMoreThanActiveFilter">
        <li :class="`${ns}__item`">
          <ActiveFiltersListClearButton @click="handleClearButtonClick" />
        </li>
      </template>
    </ul>

    <div :class="`${ns}__control`">clear it</div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'

  import ActiveFiltersListClearButton from '@/components/ActiveFiltersListClearButton'
  import ActiveFiltersListItem from '@/components/ActiveFiltersListItem'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'active-filters-list'

  export default {
    name: 'ActiveFiltersList',
    components: {
      ActiveFiltersListClearButton,
      ActiveFiltersListItem
    },
    mixins: [ bem ],
    props: {
      activeFilters: Array,
      isOnProductDetailPage: Boolean
    },
    data: function () {
      return {}
    },
    computed: {
      hasMoreThanActiveFilter: function () {
        let hasMoreThanActiveFilter = false

        if (this.activeFilters && this.activeFilters.length >= 2) {
          hasMoreThanActiveFilter = true
        }

        return hasMoreThanActiveFilter
      }
    },
    created: function () {
      this.setNamespace(namespace)
    },
    methods: {
      ...mapMutations(
        'ui',
        [
          'filtersActiveProductDetailPageRemove',
          'filtersActiveProductDetailPageRemoveAll',
          'filtersActiveProductsPageRemove',
          'filtersActiveProductsPageRemoveAll'
        ]
      ),
      handleItemClick: function (event, id) {
        // remove single item from active filters
        if (this.isOnProductDetailPage) {
          this.filtersActiveProductDetailPageRemove(id)
        } else {
          this.filtersActiveProductsPageRemove(id)
        }
      },
      handleClearButtonClick: function (event) {
        // remove all items from active filters
        if (this.isOnProductDetailPage) {
          this.filtersActiveProductDetailPageRemoveAll()
        } else {
          this.filtersActiveProductsPageRemoveAll()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ActiveFiltersList.vue